import { createGtm } from "@gtm-support/vue-gtm";

// GTM loads HubSpot Conversations, GA, and any other marketing tags
// configured inside the container. Bail out cleanly when no ID is set
// (local dev / preview envs) so the build doesn't fail.
export default defineNuxtPlugin((nuxtApp) => {
  const { gtmId } = useRuntimeConfig().public;
  if (!gtmId) return;

  // Defer the GTM bootstrap so first paint / hydration aren't competing with
  // marketing tags (LinkedIn Insight, CCM, HubSpot) that also drag Lighthouse
  // Best Practices via third-party cookies and deprecated Attribution Reporting.
  nuxtApp.vueApp.use(
    createGtm({
      id: gtmId as string,
      defer: true,
      enabled: true,
      debug: false,
      loadScript: true,
      vueRouter: useRouter(),
      trackOnNextTick: false,
      // The SSO callback lands as /auth/callback?sso=success&code=<uuid>, and that
      // code exchanges for a customer session. vue-gtm's afterEach builds its push
      // from `to.fullPath` — a router value resolved at navigation time, so the
      // address-bar scrub in 01-redact-credential-url.client.ts cannot reach it.
      // Skip the page instead: it is an interstitial that redirects immediately,
      // and the signal worth having is already carried by the sso_login_failed and
      // login_completed events.
      //
      // Verified against @gtm-support/vue-gtm@3.2.0 (dist/index.js, function v()):
      // its afterEach does
      //   if (... || (typeof ignoredViews === "function" && ignoredViews(to, from))) return;
      // BEFORE building the dataLayer push, so a truthy return genuinely
      // short-circuits the whole handler, not just the derived event name.
      // The Login as landing too: `?loginAs=` carries a live customer JWT.
      ignoredViews: (to) => to.path === "/auth/callback" || "loginAs" in to.query,
    }),
  );
});
